var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.field.value)?_c('v-card',{staticClass:"elevation-0"},[_c('v-alert',{attrs:{"type":_vm.alertType,"icon":"info","value":"true"}},[_c('h4',[_vm._v(_vm._s(_vm.field.value))]),_c('p',[_vm._v(_vm._s(_vm.field.info))])])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }